export const EntityContact = `
    entitycontact {
        pocid
        fullUid
        objectid
        contactByPocid {
            pocid
            name
            cell
            land
            email
            pubconinfo
            instruc
            datelastchanged
        }
    }
`